// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 336) return "336__" + __webpack_require__.h() + ".css";
	if (chunkId === 196) return "196__" + __webpack_require__.h() + ".css";
	if (chunkId === 113) return "113__" + __webpack_require__.h() + ".css";
	if (chunkId === 197) return "197__" + __webpack_require__.h() + ".css";
	// return url for filenames based on template
	return "" + (chunkId === 26 ? "js/bundle" : chunkId) + "_style_" + __webpack_require__.h() + ".css";
};